import { Box } from '@chakra-ui/react';
import Table from './modules/table';
import Filter from './modules/filter';
import Summary from './modules/summary';
import DetailModal from './components/detail';
import { useFilter } from './state/filters';
import { useEffect } from 'react';

export default function AuditTrailSellOut() {
    const { resetFilter } = useFilter();

    useEffect(() => {
        return () => {
            resetFilter();
        };
    }, []);
    return (
        <Box minW={'xl'}>
            <Summary />
            <Box
                bg={'white'}
                p={'24px'}
                border={'1px solid'}
                borderColor={'neutral.100'}
                borderRadius={'8px'}
                boxShadow={'sm'}
                className="table__container"
            >
                <Filter />
                <Table />
            </Box>

            <DetailModal />
        </Box>
    );
}
